<template>
  <!-- <ServerPicker /> -->
  <LevelPicker />
  <ExtraOptionPicker />
</template>

<script setup>
import ServerPicker from "./pickers/ServerPicker.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import LevelPicker from "./pickers/LevelPicker.vue";
import { onMounted } from "vue";

const { getGame, getGamePack } = useGameStore();
const { currentGamePackSlug, currentGameSlug } = useGameComposable();
const checkoutStore = useCheckoutStore();

const handleDetails = () => {
  checkoutStore.clearCheckout();
  const account_sharing = getGamePack?.pack_options?.find(
    (op) => op.const_title === "account_sharing"
  );

  if (account_sharing) {
    checkoutStore.setPackOptions({
      options: [account_sharing.id],
    });
  }
  checkoutStore.setServer(1);
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    currentLevel: 1,
    desiredLevel: 80,
  });

  checkoutStore.setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();
onMounted(() => {
  checkoutStore.setCalculating();
});
</script>
